import { render, staticRenderFns } from "./MedalDetail.vue?vue&type=template&id=7bed375a&"
import script from "./MedalDetail.vue?vue&type=script&lang=js&"
export * from "./MedalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports